<p-toast></p-toast>
<router-outlet></router-outlet>
<app-footer [ngClass]="{ 'fixed-footer': isManualPrompts }"></app-footer>
